import { FetchUtil } from "../util/FetchUtil";
import { IUserLoginServiceEndpoint } from "../models/UserProfile/IUserLoginServiceEndpoint";
import { WyanokeUtil } from "../util/WyanokeUtil";
import { StringUtil } from "../util/StringUtil";

export class UserLoginService {

    constructor(private readonly _api: IUserLoginServiceEndpoint) { }

    public async getLogin(sitename: string, contextid: string): Promise<HTMLElement | void>  {
        const api = this._api;
        const endpoint = api ? api.get : null;
        if (!endpoint) {
            console.error("Could not resolve endpoint");
            return;
        }

        const profile = await WyanokeUtil.loadUserProfile(true, false);
        if((profile?.isLoggedIn||"False") === "True") {
            console.error("Not Allowed");
            return;
        }

        const values = {
            sitename,
            contextid
        };
        const reqUrl = StringUtil.supplant(endpoint.url, values) || "";

        const result = await FetchUtil.sendMessage(
            {
                method: endpoint.method,
                url: reqUrl
            }, null, "no-cache", true
        );

        return (result as HTMLElement);
    }
}
